import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { message } from "ant-design-vue";
import store from "store2";
import qs from "qs";
//设置cookie
export function setCookie(cookiename: any, cookievalue: any) {
  const date = new Date();
  // if (type === 'milsecond') {
  //   date.setTime(date.getTime() + milsecond)
  // } else {
  date.setDate(date.getDate() + 99999);
  // }
  document.cookie =
    cookiename +
    "=" +
    cookievalue +
    ";expires = " +
    date.toUTCString() +
    ";path=/";
}
export function getCookie(cName: string) {
  const strcookie = document.cookie; // 获取cookie字符串
  const arrcookie = strcookie.split("; "); // 分割
  // 遍历匹配
  for (let i = 0; i < arrcookie.length; i++) {
    const arr = arrcookie[i].split("=");
    if (arr[0] === cName) {
      // let str = ''
      // for(let j = 1,len = arr.length;j<len;j++){
      //   str = str ? str + ''
      // }
      let newArr = arr[1];
      if (arr.length > 2) {
        arr.splice(0, 1);
        newArr = arr.join("=");
      }
      if (newArr) {
        return newArr;
      }
    }
  }
  return "";
}
//取回cookie
// export function getCookie(c_name: string) {
//   if (document.cookie.length > 0) {
//     let c_start = document.cookie.indexOf(c_name + "=");
//     if (c_start != -1) {
//       c_start = c_start + c_name.length + 1;
//       let c_end = document.cookie.indexOf(";", c_start);
//       if (c_end == -1) c_end = document.cookie.length;
//       return unescape(document.cookie.substring(c_start, c_end));
//     }
//   }
//   return "";
// }

export class Request {
  public static axiosInstance: AxiosInstance;

  public static init(): void {
    this.axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      timeout: 6000,
    });
  }

  public static initInterceptors(): void {
    this.axiosInstance.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        // 请求头自动携带 token
        // const token = store.local.get("token") || "";
        const token = getCookie("token") || "";
        if (config.headers && config.method === "post") {
          if(!config.headers["Content-Type"]){
            config.headers["Content-Type"] =
              "application/x-www-form-urlencoded;charset=UTF-8";
          }
        }
        // console.log("test1-" + token);
        // 自定义header，可添加项目token
        if (token && config.headers) {
          // console.log(`test- ${token}`);
          config.headers.token = token;
        }

        // 只有application/x-www-form-urlencoded类型才做qs对象拼接
        if (
          config.headers &&
          config.headers["Content-Type"] ===
            "application/x-www-form-urlencoded;charset=UTF-8"
        ) {
          config.data = qs.stringify(config.data);
        }

        return config;
      }
    );

    this.axiosInstance.interceptors.response.use(
      (config: AxiosResponse) => {
        const { headers, data } = config;
        const { t } = headers;
        const res = data;
        console.log("res", res);

        if (t) {
          store.local.set("token", t);
          setCookie("token", t);
          if(res.data) res.data.token = t;
        }

        // code为0，直接把结果返回回去，这样前端代码就不用在获取一次data.
        if (res.errcode === 0) {
          return res;
        }
        if (res.errcode === 1001) {
          // 10000假设是未登录状态码
          message.error(res.message, 1500, () => {
            store.local.clearAll();
            window.location.href = "/login";
          });
          return res;
        }
        // 错误显示可在service中控制，因为某些场景我们不想要展示错误
        return res;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (error: any) => {
        this.errorHandle(error);
        return Promise.reject(error);
      }
    );
  }

  /**
   * http握手错误
   * @param res 响应回调,根据不同响应进行不同操作
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static errorHandle(resError: any) {
    const error = resError;

    if (error && error.response) {
      /*
       * 1.公共错误处理
       * 2.根据响应码具体处理
       */
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          // window.location.href = "/NotFound"
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器端出错";
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      // 超时处理
      if (JSON.stringify(error).includes("timeout")) {
        message.error("服务器响应超时，请刷新当前页");
      }
      error.message = "连接服务器失败";
    }

    message.error(error.message);
  }
}
